import { css } from '@emotion/core'
import { Bleed, colors } from '@fs/zion-ui'
import React, { type CSSProperties, type ReactNode } from 'react'

const roundedCardCss = css`
  border-radius: 8px;
  border: 1px solid ${colors.transparent.gray10};
  /** Force children to respect border radius. */
  overflow: hidden;
`

const edgeToEdgeCss = css`
  border-inline: none;
  border-radius: 0;
`

type Props = {
  children: ReactNode
  /** Extend the card to the container edges (single side gutter at mobile widths), dropping the rounded corners and side borders. */
  edgeToEdge?: boolean
  style?: CSSProperties
}

export default function RoundedCard({ children, edgeToEdge = false, style }: Props): JSX.Element {
  const card = (
    <div css={[roundedCardCss, edgeToEdge && edgeToEdgeCss]} style={style}>
      {children}
    </div>
  )

  if (edgeToEdge) {
    return <Bleed sides>{card}</Bleed>
  }

  return card
}
